export default __webpack_public_path__ + "static/media/masterDev.b30c0d61.gif";